<template>
  <div class="coupon-cell">
    <div class="price">
      <div class="face">
        <span>¥</span>
        <span class="face-value">
          {{ itemData.couponValue || '' }}
        </span>
      </div>
      <div class="condition">
        {{ itemData.thresholdMsg || '' }}
      </div>
    </div>
    <div class="info">
      <div class="name">
        {{ itemData.couponDisplayName || '' }}
      </div>
      <div class="date-info">
        <div class="date">
          {{ itemData.expireStr || itemData.timeWindow || '' }}
        </div>
        <div class="btn-trans" @click="goTransfer">转赠</div>
      </div>
      <div class="desc">
        <div class="desc-text">
          {{ itemData.description || '' }}
        </div>
        <div class="btn-use" @click="goToUse">立即使用</div>
      </div>
    </div>
  </div>
</template>
<script>
import { API } from '@/api'
import { nativeRedirect } from '@/utils/native_interactions/native_redirect'
import { nativeRoutes } from '@/utils/native_interactions/native_redirect/routes'

export default {
  props: ['itemData'],
  data() {
    return {}
  },

  methods: {
    async goToUse() {
      try {
        const res = await API.coupon.getcouponpage({
          coupon_ids: this.itemData.couponId
        })
        if (res.url) {
          this.$autoRedirect(res.url)
        } else {
          nativeRedirect(nativeRoutes.goodsList)
        }
      } catch (e) {
        this.$catch(e)
      }
    },
    goTransfer() {
      const couponId = this.itemData.couponId
      this.$emit('go-transfer', couponId)
    }
  }
}
</script>
<style lang="scss" scoped>
.coupon-cell {
  position: relative;
  margin-top: 0.2rem /* 10/50 */;
  overflow: hidden;
  // height: 2.08rem /* 104/50 */;
  @include flex(row, center, stretch);
  &:first-child {
    margin-top: 0;
  }
  .price {
    @include flex(column, center, center);
    width: 1.86rem /* 93/50 */;
    text-align: center;
    background-image: url('~@/images/recharge_coupon/coupon_left.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .face {
      @include text(0.4rem /* 20/50 */, #ff3900, true);
      &-value {
        font-size: 0.72rem /* 36/50 */;
      }
    }

    .condition {
      margin-top: 0.14rem /* 7/50 */;
      @include text(0.28rem /* 14/50 */, #ff3900);
    }
  }

  .info {
    flex: 1;
    position: relative;
    width: 0;
    padding: 0.28rem /* 14/50 */ 0.24rem /* 12/50 */ 0.28rem /* 14/50 */
      /* 11/50 */ 0.4rem /* 20/50 */;
    background-image: url('~@/images/recharge_coupon/coupon_right.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .name {
      @include text(0.32rem /* 16/50 */, #262626, true);
      @include text-overflow-ellipsis;
    }
    .date-info {
      margin-top: 0.12rem /* 6/50 */;
      @include flex-row-between;
    }
    .date {
      @include text(0.24rem /* 12/50 */, #ff3900);
      @include text-overflow-ellipsis;
      width: 3rem /* 150/50 */;
    }
    .desc {
      margin-top: 0.12rem /* 6/50 */;
      @include flex-row-between;
    }

    .desc-text {
      width: 3rem /* 150/50 */;
      @include text(0.24rem /* 12/50 */, #999999);
      @include text-overflow-ellipsis;
    }

    .btn-use {
      @include flex-row-center;
      font-size: 0.24rem /* 12/50 */;
      color: #262626;
      width: 1.44rem /* 72/50 */;
      height: 0.48rem /* 24/50 */;
      border-radius: 0.26rem /* 13/50 */;
      background-color: #fff;
      border: 1px solid #8c8c8c;
      box-sizing: border-box;
    }
    .btn-trans {
      @include flex-row-center;
      font-size: 0.24rem /* 12/50 */;
      color: #f45e33;
      width: 1.44rem /* 72/50 */;
      height: 0.48rem /* 24/50 */;
      border-radius: 0.26rem /* 13/50 */;
      background-color: #fff;
      border: 1px solid #f45e33;
      box-sizing: border-box;
    }
  }
}
</style>
